import { SvelteDate } from 'svelte/reactivity';

export const useClock = () => {
  let now = $state(Date.now());
  $effect(() => {
    const interval = setInterval(() => {
      now = Date.now();
    }, 1_000);
    return () => clearInterval(interval);
  });
  return {
    get now() {
      return now;
    },
  };
};

export const formatTime = (ms: number) =>
  new SvelteDate(ms).toLocaleString('nb-NO');

export const formatDuration = (seconds: number) =>
  `${Math.floor(seconds / 60)}:${String(Math.round(seconds % 60)).padStart(2, '0')}`;

export const formatTimeLeft = (
  openedAt: number | null | undefined,
  now: number
): string | null => {
  if (openedAt == null) {
    return null;
  }
  return formatDuration(Math.ceil(Math.max(0, openedAt - now) / 1000));
};
